import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { email, password };
    console.log("🚀 Payload sending to backend:", payload);

    try {
      const res = await fetch("https://api.pdf.tajgateways.com/api-v1/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      console.log("✅ API Response:", result);

      if (result.code === 200) {
        const userRole = result.data.user.role || "user";
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("user", JSON.stringify(result.data.user));
        localStorage.setItem("role", userRole);
        localStorage.setItem("isLoggedIn", "true");
        onLogin();
      } else {
        setError(result.message || "Login failed");
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div style={styles.container}>
      {/* Inject responsive CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            .login-card {
              width: 65% !important;
              padding: 8px 20px !important;
            }
            .login-title {
              font-size: 20px !important;
            }
            input {
              font-size: 14px !important;
              padding: 10px !important;
              width: 100% !important;
            }
            button {
              font-size: 14px !important;
              padding: 10px !important;
            }
            form {
            padding: 20px !important;
            width: 83% !important;
          }
          }

          @media (max-width: 480px) {
            .login-card {
              padding: 20px 15px !important;
            }
            .login-title {
              font-size: 18px !important;
            }
            input {
              font-size: 13px !important;
              padding: 9px !important;
            }
            button {
              font-size: 13px !important;
              padding: 9px !important;
            }
            form {
            padding: 20px !important;
            width: 83% !important;
          }
        `}
      </style>

      <div style={styles.cardWrapper}>
        <div style={styles.card} className="login-card">
          <h2 style={styles.title} className="login-title">🔐 Admin Login</h2>

          <form onSubmit={handleSubmit} style={styles.form}>
            {/* Email */}
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />

            {/* Password */}
            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ ...styles.input, paddingRight: "35px" }}
              />
              <span
                style={styles.icon}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" style={styles.button}>
              Login
            </button>

            {error && <p style={styles.error}>{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

// ✅ Styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #6dd5ed, #2193b0)",
    padding: "20px",
    boxSizing: "border-box",
  },
  cardWrapper: {
    textAlign: "center",
    width: "100%",
  },
  card: {
    background: "#fff",
    padding: "40px 30px",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    width: "350px",
    maxWidth: "90vw",
    margin: "0 auto",
    textAlign: "center",
    transition: "all 0.3s ease",
  },
  title: {
    marginBottom: "20px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "600",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "12px",
    margin: "8px 0",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    outline: "none",
    transition: "0.3s",
    width: "100%",
    boxSizing: "border-box",
  },
  passwordWrapper: {
    position: "relative",
    width: "100%",
  },
  icon: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#555",
    fontSize: "18px",
  },
  button: {
    marginTop: "15px",
    padding: "12px",
    background: "#2193b0",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s",
  },
  error: {
    marginTop: "12px",
    color: "red",
    fontSize: "14px",
  },
};

export default Login;
